import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { useEffect, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import Camera from '@/assets/svgs/permission/camera.svg';
import ImgPicker from '@/assets/svgs/permission/img-picker.svg';
import Location from '@/assets/svgs/permission/location.svg';
import Notification from '@/assets/svgs/permission/notification.svg';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import type { DeviceTokenData } from '@/stores/DeviceStore';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { useHandleApp } from '../_hooks/useHandleApp';
import { MESSAGE_KEYWORD } from '../_utils/reserved-keywords';
export const AppModal = () => {
  const $ = _c(53);
  const [appModal, setAppModal, setTempDeviceTokenData] = useDeviceInfoStore(useShallow(_temp));
  const {
    isOpened,
    type
  } = appModal;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      type: MESSAGE_KEYWORD.EXIT_APP
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    request: requestExit
  } = useHandleApp(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: MESSAGE_KEYWORD.RESTART_APP
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    request: requestRestart
  } = useHandleApp(t1);
  let t2;
  if ($[2] !== setAppModal || $[3] !== type) {
    t2 = () => setAppModal({
      type,
      isOpened: false
    });
    $[2] = setAppModal;
    $[3] = type;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const closeModal = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      type: MESSAGE_KEYWORD.CHECK_PERMISSION
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    request: requestCheckPermission
  } = useHandleApp(t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      type: MESSAGE_KEYWORD.NOTIFICATION
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    request: requestNotification,
    response: notificationResponse
  } = useHandleApp(t4);
  const [isSwiftPending, setIsSwiftPending] = useState(false);
  let t5;
  let t6;
  if ($[7] !== isSwiftPending || $[8] !== requestNotification) {
    t5 = () => {
      if (!isSwiftPending) {
        return;
      }
      if (navigator.userAgent.includes("swift") || navigator.userAgent.includes("ios")) {
        const id = setTimeout(requestNotification, 5000);
        return () => clearTimeout(id);
      }
    };
    t6 = [isSwiftPending, requestNotification];
    $[7] = isSwiftPending;
    $[8] = requestNotification;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[11] !== notificationResponse || $[12] !== requestCheckPermission || $[13] !== setTempDeviceTokenData) {
    t7 = () => {
      const {
        data,
        isSuccess
      } = notificationResponse ?? {};
      if (isSuccess && data) {
        if (navigator.userAgent.includes("swift") || navigator.userAgent.includes("ios")) {
          if (data.fcm_token) {
            setTempDeviceTokenData(data);
            setIsSwiftPending(false);
          } else {
            setIsSwiftPending(true);
          }
        } else {
          setTempDeviceTokenData(data);
        }
        requestCheckPermission({
          permissionType: MESSAGE_KEYWORD.LOCATION
        });
      }
    };
    t8 = [notificationResponse, requestCheckPermission, setTempDeviceTokenData];
    $[11] = notificationResponse;
    $[12] = requestCheckPermission;
    $[13] = setTempDeviceTokenData;
    $[14] = t7;
    $[15] = t8;
  } else {
    t7 = $[14];
    t8 = $[15];
  }
  useEffect(t7, t8);
  let t9;
  if ($[16] !== closeModal || $[17] !== type) {
    t9 = () => {
      if (type !== "permission") {
        closeModal();
      }
    };
    $[16] = closeModal;
    $[17] = type;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <h2 className="mb-8 font-700 typo-body1">서비스 이용을 위한<br />권한 접근이 필요해요.</h2>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <section className="flex flex-col gap-16 border-b-1 border-Gray-300 pb-20"><div className="flex flex-col gap-2"><h3 className="font-600 text-Gray-900 typo-body4">필수 접근 권한</h3><p className="text-Gray-600 typo-body4">필수적 접근 권한 없음</p></div></section>;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex flex-col gap-2"><h3 className="font-600 text-Gray-900 typo-body4">선택적 접근 권한</h3><p className="text-Gray-600 typo-body4">선택적 접근 권한은 해당 기능을 사용할 때 허용이 필요하며, 비허용 시에도 해당 기능 외 서비스 이용이 가능합니다.</p></div>;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <section className="flex flex-col gap-16 border-b-1 border-Gray-300 pb-20">{t12}<ul className="flex flex-col gap-10 px-16">{[{
          icon: Notification,
          title: "\uC54C\uB9BC(\uC120\uD0DD)",
          description: "\uAC1C\uC778\uBCC4 \uB9DE\uCDA4 \uC815\uBCF4 \uC54C\uB9BC"
        }, {
          icon: Location,
          title: "\uC704\uCE58(\uC120\uD0DD)",
          description: "\uAC80\uC0C9 \uBC0F \uB3D9\uB124\uC18C\uC2DD\uC5D0\uC11C \uD604\uC7AC \uC704\uCE58 \uC0AC\uC6A9"
        }, {
          icon: Camera,
          title: "\uCE74\uBA54\uB77C(\uC120\uD0DD)",
          description: "\uB2F5\uB840\uD488 \uD6C4\uAE30, \uBB38\uC758, \uD504\uB85C\uD544 \uC774\uBBF8\uC9C0 \uB4F1\uB85D"
        }, {
          icon: ImgPicker,
          title: "\uC0AC\uC9C4(\uC120\uD0DD)",
          description: "\uB2F5\uB840\uD488 \uD6C4\uAE30, \uBB38\uC758, \uD504\uB85C\uD544 \uC774\uBBF8\uC9C0 \uB4F1\uB85D"
        }].map(_temp2)}</ul></section>;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="flex flex-1 flex-col gap-20 overflow-y-auto">{t11}{t13}<section className="flex flex-col gap-16 pb-16"><div className="flex flex-col gap-2"><h3 className="font-600 text-Gray-900 typo-body4">접근 권한 변경 방법</h3><p className="text-Gray-600 typo-body4">휴대폰 설정 {">"} 앱 또는 애플리케이션 관리 {">"} 웰로{" "}{">"} 권한에서 각 권한별 변경 가능합니다.</p></div></section></div>;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== closeModal || $[25] !== requestNotification) {
    t15 = <article className="flex h-full max-h-[70vh] flex-col">{t10}{t14}<Button className="mt-16" onClick={async () => {
        requestNotification();
        closeModal();
      }}>확인</Button></article>;
    $[24] = closeModal;
    $[25] = requestNotification;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  let t17;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <h2 className="text-center font-700 typo-h5">앱을 나가시겠어요?</h2>;
    t17 = <p className="mb-16 text-Gray-600 typo-body4">더이상 뒤로 갈 페이지가 없어요.</p>;
    $[27] = t16;
    $[28] = t17;
  } else {
    t16 = $[27];
    t17 = $[28];
  }
  let t18;
  if ($[29] !== closeModal) {
    t18 = <Button onClick={closeModal}>계속 볼게요</Button>;
    $[29] = closeModal;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== requestExit) {
    t19 = <Button theme="sub-text" onClick={() => requestExit()}>나갈게요</Button>;
    $[31] = requestExit;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t18 || $[34] !== t19) {
    t20 = <article className="flex flex-col items-center gap-8">{t16}{t17}{t18}{t19}</article>;
    $[33] = t18;
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <h2 className="text-center font-700 typo-h5">앱이 업데이트 되었어요!</h2>;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <p className="mb-16 text-Gray-600 typo-body4">사용자들의 의견을 반영한 업데이트가 있어요.<br />업데이트 하고 신규 기능을 이용해 보세요.</p>;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== requestRestart) {
    t23 = <Button onClick={() => requestRestart()}>업데이트</Button>;
    $[38] = requestRestart;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== closeModal) {
    t24 = <Button theme="sub-text" onClick={closeModal}>다음에 할래요</Button>;
    $[40] = closeModal;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t23 || $[43] !== t24) {
    t25 = <article className="flex flex-col items-center gap-8">{t21}{t22}{t23}{t24}</article>;
    $[42] = t23;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t15 || $[46] !== t20 || $[47] !== t25) {
    t26 = {
      permission: t15,
      exit: t20,
      restart: t25
    };
    $[45] = t15;
    $[46] = t20;
    $[47] = t25;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  const t27 = t26[type];
  let t28;
  if ($[49] !== isOpened || $[50] !== t27 || $[51] !== t9) {
    t28 = <ResponsiveDialog opened={isOpened} onClose={t9} drawerType="bottom">{t27}</ResponsiveDialog>;
    $[49] = isOpened;
    $[50] = t27;
    $[51] = t9;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  return t28;
};
function _temp(state) {
  return [state.appModal, state.setAppModal, state.setTempDeviceTokenData];
}
function _temp2(t0, index) {
  const {
    icon: Icon,
    title,
    description
  } = t0;
  return <li key={index} className="flex items-center gap-16"><div className="size-48 rounded-pill bg-Gray-100 flex-center"><Icon alt={title} /></div><div className="flex flex-col gap-2"><h4 className="font-700 text-Gray-900 typo-body4">{title}</h4><p className="text-Gray-600 typo-body4">{description}</p></div></li>;
}